import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://9a54274c5886f7bb6c7308b4c705d5ff@o4507579915632640.ingest.de.sentry.io/4507579937128528",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});